import React from 'react';
import './Stub.css';

function AbstractArt() {
  return (
    <div className="stub-page">
      <h1>Abstract Art</h1>
      <p>Coming soon.</p>
    </div>
  );
}

export default AbstractArt;
